module.exports = __webpack_public_path__ + "media/logos/google-c60d1222.svg";